import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NotificationComponent } from '@shared/components/notification/notification';

@Component({
  selector: 'app-auth-layout',
  imports: [RouterOutlet, NotificationComponent],
  templateUrl: './auth-layout.html',
  styleUrl: './auth-layout.scss',
})
export class AuthLayout {}
